import React from 'react'
import { Box } from '@mui/material'
import CampaignHeader from './CampaignHeader'
import CampaignInfo from './CampaignInfo'
import CampaignNavigationTabs from './CampaignNavigationTabs'
import CampaignLimits from './CampaignLimits'

const ScrollWrapper = ({ children, style = {} }) => {
  return <div style={{ overflowX: 'hidden', flex: 1, ...style }}>{children}</div>
}

const CampaignSidebarContent = ({ campaignDetails, tabs, activeTab, onTabChange, limits }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <ScrollWrapper>
        {/* Campaign context card */}
        {campaignDetails && (
          <Box sx={{
            mx: 2,
            mb: 2,
            p: 2,
            borderRadius: 2,
            backgroundColor: 'rgba(0, 0, 0, 0.02)',
            border: '1px solid',
            borderColor: 'divider'
          }}>
            <CampaignHeader campaignDetails={campaignDetails} />
            <CampaignInfo campaignDetails={campaignDetails} />
          </Box>
        )}

        {/* Navigation */}
        <CampaignNavigationTabs
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={onTabChange}
        />
      </ScrollWrapper>

      {/* Limits pinned at bottom */}
      <Box data-tour="campaign-limits" sx={{ p: 2, borderTop: '1px solid', borderColor: 'divider' }}>
        <CampaignLimits limits={limits} />
      </Box>
    </Box>
  )
}

export default CampaignSidebarContent
